/* ----------------- Hooks Imports --------------- */
import { pageViewTypes } from "@constants/tracking";
import ProgressView from "@features/dashboard/components/Progress/ChallengeProgressView";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";

import CustomAppbar from "components/CustomAppbar";
import CustomTabs from "components/CustomTabs";
/* ----------------- Components Imports --------------- */
import DocumentTitle from "components/DocumentTitle";
import LeaderboardContainer from "../screens/LeaderboardContainer";
const ChallengeProgressContainer = () => {
	const { isMobile } = useDevice();

	const tabs = [
		{
			label: "Progress",
			content: <ProgressView />,
		},
		{
			label: "Leaderboard",
			content: <LeaderboardContainer />,
		},
	];

	const theme = useAppTheme();
	useAnalytics({
		type: pageViewTypes.insights,
	});
	return (
		<>
			<CustomAppbar
				showCommandBar={isWeb}
				align="flex-start"
				elevated={false}
				mode="small"
				style={{
					backgroundColor: theme.colors.elevation.level3,
				}}
				options={{
					headerTitle: "Insights",
					subtitle: isMobile ? undefined : "Your insights",
				}}
			/>

			<DocumentTitle title="Insights" />
			<CustomTabs tabs={tabs} />
		</>
	);
};

export default ChallengeProgressContainer;
